import React, { useState } from 'react';
import {
  Td,
  HStack,
  IconButton,
  Button,
  Tooltip,
  useDisclosure,
} from '@chakra-ui/react';
import TaskCompletionModal from './TaskCompletionModal';
import { PhoneIcon, ViewIcon, CloseIcon } from '@chakra-ui/icons';
import NewKBRecordCallModal from '../leads/NewKB/components/NewKBRecordCallModal';
import NewKBLeadModal from '../leads/NewKB/components/NewKBLeadModal';

/**
 * Actions component for task rows
 */
export const TaskActions = ({ task, isHeader = false }) => {
  const { isOpen: isCallModalOpen, onOpen: onCallModalOpen, onClose: onCallModalClose } = useDisclosure();
  const { isOpen: isLeadModalOpen, onOpen: onLeadModalOpen, onClose: onLeadModalClose } = useDisclosure();

  return (
    <>
      {isHeader ? (
        <HStack spacing={1} mr={3}>
          <Tooltip label="Record Call">
            <IconButton
              icon={<PhoneIcon />}
              size="xs"
              colorScheme="blue"
              variant="ghost"
              onClick={onCallModalOpen}
              aria-label="Record Call"
              minW="20px"
              h="20px"
              borderRadius="md"
            />
          </Tooltip>
          
          <Tooltip label="View Lead">
            <IconButton
              icon={<ViewIcon />}
              size="xs"
              colorScheme="teal"
              variant="ghost"
              onClick={onLeadModalOpen}
              aria-label="View Lead"
              minW="20px"
              h="20px"
              borderRadius="md"
            />
          </Tooltip>
        </HStack>
      ) : (
        <Td py="1" px="0">
          <HStack spacing={0.5}>
            <Tooltip label="Record Call">
              <IconButton
                icon={<PhoneIcon />}
                size="xs"
                colorScheme="blue"
                variant="outline"
                onClick={onCallModalOpen}
                aria-label="Record Call"
              />
            </Tooltip>
            
            <Tooltip label="View Lead">
              <Button
                size="xs"
                colorScheme="teal"
                variant="outline"
                onClick={onLeadModalOpen}
                w="32px"
                h="32px"
                borderRadius="50%"
                p={0}
              >
                👤
              </Button>
            </Tooltip>
          </HStack>
        </Td>
      )}
      
      {/* Call Recording Modal */}
      <NewKBRecordCallModal
        isOpen={isCallModalOpen}
        onClose={onCallModalClose}
        lead={task.leadDetails || { leadId: task.leadId }}
        onSuccess={() => {}}
      />
      
      {/* Lead Modal */}
      <NewKBLeadModal
        isOpen={isLeadModalOpen}
        onClose={onLeadModalClose}
        leadId={task.leadId}
      />
    </>
  );
};

/**
 * Status toggle for task status with completion modal
 */
export const StatusToggle = ({ task, onStatusChange }) => {
  const [isCompletionModalOpen, setIsCompletionModalOpen] = useState(false);
  
  // Only show modal when marking as complete, not when marking as pending
  const handleStatusToggle = () => {
    // If already completed, just toggle back to pending
    if (task.status === 'completed') {
      onStatusChange(task._id, 'pending');
      return;
    }
    
    // If pending, show modal to collect additional information
    setIsCompletionModalOpen(true);
  };

  // Handle task completion with additional data
  const handleTaskCompletion = (taskId, status, completionData) => {
    onStatusChange(taskId, status, completionData);
  };

  return (
    <>
      <Td py="1" px="0" textAlign="center">
        <IconButton
          icon={task.status === 'completed' ? <ViewIcon /> : null}
          size="xs"
          aria-label={`Mark task ${task.status === 'completed' ? 'pending' : 'complete'}`}
          onClick={handleStatusToggle}
          colorScheme={task.status === 'completed' ? 'green' : 'gray'}
          variant={task.status === 'completed' ? 'solid' : 'outline'}
          borderRadius="full"
          w="20px"
          h="20px"
        />
      </Td>
      
      <TaskCompletionModal
        isOpen={isCompletionModalOpen}
        onClose={() => setIsCompletionModalOpen(false)}
        task={task}
        onComplete={handleTaskCompletion}
        currentFollowUp={task.leadDetails?.nextFollowUp}
      />
    </>
  );
};
